import React, { useState, useEffect, useRef } from 'react';
import { Canvas } from '@react-three/fiber';
import * as THREE from 'three';
import Scribble from '../../Utils/Scribble.js';
import SceneComponent from './SceneComponent';
import { ModelListPK } from "../../Utils/ModelsList.js"
import LayerControl from './LayerControl'; // Import LayerControl component
import Measurements from '../../clickTools/Measurements.js';
import Info from '../../clickTools/Info.js';
import ColorChange from '../../clickTools/ColorChange.js';
import ObjectDetails from '../../clickTools/ObjectDetails.js';
import { useProgress } from '@react-three/drei';
import InfoControl from './InfoControl.js';
import StopeStatistics from './StopeStatistics.js';
import ObjectDetailsPage from './ObjectDetailsPage.js';
import { SceneSlicer } from '../SceneSlicer/index.jsx';
import Slidethumbnail from './Slidethumbnail.js';
import BottomBarContainer from './BottomBarContainer.js';
import UnifiedPanel from './UnifiedPanel.js';
import { useClickStore } from '../../store/clickStore.js';
import { useShallow } from 'zustand/react/shallow';

const Presentation = ({ userEmail, onLogout }) => {

  const [three, setThree] = useState(null)
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)
  
  const { progress } = useProgress()

  const slicerPortal = useRef(null)

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isScribbleMode, setIsScribbleMode] = useState(false);
  const [selectedColor, setSelectedColor] = useState('black');
  const [previousSlideWasScene, setPreviousSlideWasScene] = useState(false);
  const [showDescription, setShowDescription] = useState(true); // Track description visibility

  // Automatically close sidebar on medium screens and below
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) { // Adjust the breakpoint as needed
        setIsSidebarOpen(false);
      }
    };

    // Initial check and add event listener
    handleResize();
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);




  // Define the slides, with some containing scene-specific content
  const slides = [
    { type: 'image', heading: 'PICKSTONE MINE', content: './presentation/pickstone1.jpg' },
    //{ type: 'video', heading: 'Video Slide', content: './presentation/pp.mp4' },
    //{ type: 'youtube', heading: 'YouTube Slide', content: 'https://www.youtube.com/embed/ABS9ipi-LmU' },
    // {
    //   type: 'scene',
    //   heading: '3D Scene 1',
    //   content: {
    //     visibleObjects: ['eu_pit', 'SouthDump'],
    //     cameraPosition: [5, 500, 5],
    //     lookAt: [0, 0, 0]
    //   }
    // }
    {
      type: 'scene',
      heading: 'Overview',
      content: {
        visibleObjects: ['PK_PIT','PE_PIT','RTZ_SHAFTS','RTZ_DRIVES','RTZ_STOPES','PickstoneOrebody111024','ConcessionOrebody111024','PK_MODEL','PE_GRADESHALE'],
        cameraPosition: [-627, 4000,-388],
        lookAt: [-627, 0, -389],
        description:`<strong>PK Pit</strong>: Depth: 100 meters<strong> • </strong> Associated Orebody: PK Orebody<strong> • </strong> Strike Length: 1 kilometer<strong> • </strong> Reef Width: 3 meters<strong> • </strong> Features: Banded Iron Formation (BIF), Southwell Shaft, Burnett Shaft, Concession Shaft.<br>
                    <strong>PE Pit</strong>: Depth: 150 meters<strong> • </strong> Associated Orebody: PE Orebody<strong> • </strong> Strike Length: 1.5 kilometers<strong> • </strong> Reef Width: 5 meters<strong> • </strong> Features: Concession Hill, Additional Reef Width: 1.5 meters.`
      }
    },{
      type: 'scene',
      heading: 'Underground',
      content: {
        visibleObjects: [
          ,'RTZ_SHAFTS','RTZ_DRIVES','RTZ_STOPES','RollerTrend','PE_CROSSCUT'
        ],
        cameraPosition: [-980, 489,3100],
        lookAt: [-579, -278, 137],
        description: `<strong>PK Underground Workings (Known)</strong>: From 1 Level to 14 Level<strong> • </strong> 3 Main Shafts<strong> • </strong> Conceptual Ore Body<strong> • </strong> Key Shafts: Southwell Shaft, Burnett Shaft, Concession Shaft.<br>`
                    //<strong>PK Other Workings</strong>: PK Void Scanning<strong> • </strong> Concession West (voids to the west)<strong> • </strong> PK East to China City (new shafts).`
      }
    },{
      type: 'scene',
      heading: 'Model Comparisons',
      content: {
        visibleObjects: ['PK_PIT','RTZ_SHAFTS','RTZ_DRIVES','RTZ_STOPES','PK_MODEL','PK_GEO_HG'],
        cameraPosition: [754, -297,1604],
        lookAt: [-125, -490, 15],
        description :`<strong>PK HG Ore Body</strong><br><strong>PK Conceptual Orebody</strong>: Open at depth<strong> • </strong><strong>Depth</strong>: 1,500 meters`
      }
    },{
      type: 'scene',
      heading: 'PK Phase1',
      content: {
        visibleObjects: [
          // '1L_STOPE', '2L_SCAN', '2L_STOPE', '2L_STOPE01', '2L_WINZE', '3L_SCAN', '3L_STOPE', '3L_STOPE01', '3L_STOPE02', '3L_STOPE03', '3L_STOPE04', '4L_SCAN', '4L_SL_SCAN', '5L_SCAN', '6L_SCAN', '7L_SCAN',
          'SCANS',
          'SURVEY_0724',
          'PK_PIT','RTZ_SHAFTS','RTZ_DRIVES','RTZ_STOPES','STOPES_P1'],
          cameraPosition: [-537, -251,1248],
          lookAt: [-318, -309, -145],
        description : `<strong>PK Pit</strong><br><strong>Levels</strong>: 2L to 6L<strong> • </strong><strong>Phase</strong>: Phase 1 LOM<strong> • </strong><strong>Completion Date</strong>: June 2025<strong> • </strong><strong>Features</strong>: Lobe Shaft, 5L Conveyor`
      }
    },{
      type: 'scene',
      heading: 'PK Phase2',
      content: {
        visibleObjects: ['PK_PIT','RTZ_SHAFTS','RTZ_DRIVES','RTZ_STOPES','STOPES_P1','STOPES_P2'],
        cameraPosition: [-537, -251,1248],
        lookAt: [-318, -309, -145],
        description : `Southwell Shaft • 10L loading station • Burnett Shaft • PK Underground workings • From 6L to 14 Level • 2 main shafts • Southwell Shaft • Burnett Shaft • Concession Ventilation Shaft • LOM to December 2028`
      }
    },
    
    // {
    //   type: 'scene',
    //   heading: 'Short Term Plan',
    //   content: {
    //     visibleObjects: ['RTZ_SHAFTS','RTZ_DRIVES','RTZ_STOPES','STOPES_P1','STOPES_P2','DRILLING_TARGETS'],
    //     cameraPosition: [-561, -130,710],
    //     lookAt: [-423, -166, -167],
    //     description : `November 2024: Stopes, Tons and grades, Development metres • December 2024: Stopes, Tons and grades, Development metres • January 2025: Stopes, Tons and grades, Development metres • FY2025: Stopes, Development per month`
    //   }
    // },
    {
      type: 'scene',
      heading: 'Diamond Drilling',
      content: {
        visibleObjects: ['PK_PIT','RTZ_SHAFTS','RTZ_DRIVES','RTZ_STOPES','PKUG_DD'],
        cameraPosition: [-638, -13,23],
        lookAt: [-361, -134, -200],
        description : `PK Underground Diamond Drilling • PKUG Surface Holes • PKUG 4L holes and 6L holes • PKUG Channels`
      }
    },{
      type: 'scene',
      heading: 'New Orebodies',
      content: {
        visibleObjects: ['PK_PIT','RTZ_SHAFTS','RTZ_DRIVES','RTZ_STOPES','PKUG_DD','PickstoneOrebody111024','ConcessionOrebody111024'],
        cameraPosition: [-2053, 753,440],
        lookAt: [-769, -367, -485],
        description : `Duchess West: 0L to 4L, 50,000t of ore • Concession Hill: 0L to 5L, 30,000t of ore • Pickstone trend to Road Shaft or Peerless waste dump • Include new decline to 5L`
      }
    },{
      type: 'scene',
      heading: 'Deeps drilling',
      content: {
        visibleObjects: ['PK_PIT','PE_PIT','RTZ_SHAFTS','RTZ_DRIVES','RTZ_STOPES','PK_MODEL','DEEPS','PLANNED_CUBBIES'],
        cameraPosition: [1125, 654,-675],
        lookAt: [-180, -480, -90],
        description : `Target 16 Level • 1,200m deep hole • Target from 10L`
      }
    },
    {
      type: 'scene',
      heading: 'Central',
      content: {
        visibleObjects: ['4L_Central','12L_Central','24L_Central','Conveyor','CentralShaft','PeerlessWestDecline','CentralMainDecline','CentralMainDecline','RTZ_DRIVES','RTZ_DRIVES','RTZ_STOPES','PE_BLACKSHALE','PE_PIT','CH_MODEL_B','PK_MODEL_B','DH_MODEL_B'],
        cameraPosition: [-627, 4000,-388],
        lookAt: [-627, 0, -389],
        description:`<strong>Central Design</strong>`
      }
    },
    { type: 'image', heading: 'END', content: './presentation/end.jpg' }
  ];

  const handleSlideClick = (index) => {
    setPreviousSlideWasScene(slides[currentSlide].type === 'scene');
    setCurrentSlide(index);
    setIsScribbleMode(false); // Disable scribble mode on page change
    
    setShowDescription(true)
    


    const newVisibility = { ...layerVisibility };
    
    // Reset all layers to invisible
    Object.keys(newVisibility).forEach((key) => {
      newVisibility[key].visible = false;
    });

    // Enable only the layers specified in the slide's visibleObjects
    const visibleObjects = slides[index]?.content?.visibleObjects || [];
    visibleObjects.forEach((name) => {
      if (newVisibility[name]) {
        newVisibility[name].visible = true;
      }
    });

    setLayerVisibility(newVisibility);
  };

  const handleToggleScribbleMode = () => {
    setIsScribbleMode(!isScribbleMode);
  };

  const renderSlideContent = () => {
    const slide = slides[currentSlide];
    switch (slide.type) {
      case 'image':
        return <img src={slide.content} alt="Slide" className="max-w-full max-h-full mx-auto overflow-hidden" />;

      case 'video':
        return (
          <video controls className="max-w-full max-h-full mx-auto">
            <source src={slide.content} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        );

      case 'youtube':
        return (
          <iframe
            width="100%"
            height="100%"
            src={slide.content}
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="max-w-full max-h-full mx-auto"
          ></iframe>
        );

      case 'scene':
        return null; // We render the Canvas separately for scene slides

      default:
        return null;
    }
  };


  //////////LAYER VISIBILITY////////////////
  
  const [layerVisibility, setLayerVisibility] = useState({}); // Manage visibility of each layer
  const [showUnifiedPanel, setShowUnifiedPanel] = useState(false);
  const [activePanel, setActivePanel] = useState('layers'); // 'layers', 'information', 'statistics'
  const [panelWidth, setPanelWidth] = useState('default'); // 'default', '25', '50', '75', '100'
  // Remove local showMeasurements state - now using store
  const [isControlPanelCollapsed, setIsControlPanelCollapsed] = useState(true); // Toggle for Measurements visibility
  const [backgroundMode, setBackgroundMode] = useState(0); // 0: default gradient, 1: white, 2: black

  // Fly-around state management
  const { isFlyAroundActive, setFlyAround, showMeasurements, setShowMeasurements } = useClickStore(
    useShallow((state) => ({
      isFlyAroundActive: state.isFlyAroundActive,
      setFlyAround: state.setFlyAround,
      showMeasurements: state.showMeasurements,
      setShowMeasurements: state.setShowMeasurements,
    }))
  );

  // North arrow rotation state
  const [northArrowRotation, setNorthArrowRotation] = useState(0);

  // Log when showMeasurements changes
  useEffect(() => {
    // Track measurements visibility state
  }, [showMeasurements]);

  // Handle keyboard shortcut for toggling unified panel
  useEffect(() => {
    const handleToggleUnifiedPanel = () => {
      setShowUnifiedPanel(!showUnifiedPanel);
    };

    window.addEventListener('toggleUnifiedPanel', handleToggleUnifiedPanel);

    return () => {
      window.removeEventListener('toggleUnifiedPanel', handleToggleUnifiedPanel);
    };
  }, [showUnifiedPanel]);

  // Update north arrow rotation based on camera rotation
  useEffect(() => {
    if (!three || !three.camera) return;

    const updateNorthArrow = () => {
      const camera = three.camera;
      
      // Get camera's rotation around Y-axis (azimuth)
      // We need to calculate the angle between camera's forward direction and the positive Z-axis
      const cameraDirection = new THREE.Vector3();
      camera.getWorldDirection(cameraDirection);
      
      // Project the camera direction onto the XZ plane (ignore Y component)
      const horizontalDirection = new THREE.Vector3(cameraDirection.x, 0, cameraDirection.z).normalize();
      
      // Calculate angle between horizontal direction and positive Z-axis
      // Atan2 gives us the angle from Z+ axis to the camera direction
      const angle = Math.atan2(horizontalDirection.x, horizontalDirection.z);
      
      // Convert to degrees and handle quadrants properly
      let degrees = (angle * 180 / Math.PI);
      
      // Normalize to 0-360 range
      if (degrees < 0) {
        degrees += 360;
      }
      
      // For the north arrow, we want it to point in the opposite direction
      // of where the camera is looking, so we add 180 degrees
      degrees = (degrees + 180) % 360;
      
      setNorthArrowRotation(degrees);
    };

    // Update immediately
    updateNorthArrow();

    // Set up animation frame loop to continuously update
    const animationId = requestAnimationFrame(function animate() {
      updateNorthArrow();
      requestAnimationFrame(animate);
    });

    return () => {
      cancelAnimationFrame(animationId);
    };
  }, [three]);
  
  useEffect(() => {
    const initialVisibility = {};
    ModelListPK.forEach((group) => {
      group.models.forEach((model) => {
        initialVisibility[model.name] = { visible: false, url: model.url };
      });
    });
    setLayerVisibility(initialVisibility);
  }, []);

  // Apply background to CSS
  useEffect(() => {
    const root = document.documentElement;
    
    // Cycle through three background modes
    switch (backgroundMode) {
      case 0: // Default gradient
        root.style.setProperty('--gradient-bg', 'radial-gradient(#4a4a4a, #212121)');
        break;
      case 1: // White background
        root.style.setProperty('--gradient-bg', 'white');
        break;
      case 2: // Black background
        root.style.setProperty('--gradient-bg', 'black');
        break;
      default:
        root.style.setProperty('--gradient-bg', 'radial-gradient(#4a4a4a, #212121)');
    }
  }, [backgroundMode]);

   // Toggle visibility of layers from LayerControl
  const handleToggleVisibility = (modelName) => {
    setLayerVisibility((prevState) => ({
      ...prevState,
      [modelName]: {
        ...prevState[modelName],
        visible: !prevState[modelName].visible,
      }
    }));
  };

  // Get first initial of user email
  const getUserInitial = () => {
    if (!userEmail) return 'U';
    return userEmail.charAt(0).toUpperCase();
  };

  // Handle logout confirmation
  const handleLogoutClick = () => {
    setShowLogoutConfirm(true);
  };

  const handleLogoutConfirm = () => {
    onLogout();
    setShowLogoutConfirm(false);
  };

  const handleLogoutCancel = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <div className="flex h-screen relative">
      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm mx-4 shadow-xl">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center mr-3">
                <span className="text-black font-bold text-lg">{getUserInitial()}</span>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Logout</h3>
                <p className="text-sm text-gray-600">Are you sure you want to logout?</p>
              </div>
            </div>
            <div className="flex justify-end space-x-3">
              <button
                onClick={handleLogoutCancel}
                className="px-4 py-2 text-gray-600 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors duration-200"
              >
                Cancel
              </button>
              <button
                onClick={handleLogoutConfirm}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Sidebar */}
      <div className={`transition-all duration-300 bg-black text-white h-full flex flex-col ${isSidebarOpen ? 'w-48' : 'w-12'}`}>
        {/* User Profile Button */}
        <div className="relative flex justify-center mb-2">
          <button
            onClick={handleLogoutClick}
            className="w-10 h-10 bg-gradient-to-r from-yellow-500 to-yellow-600 text-black rounded-full shadow-lg hover:from-yellow-400 hover:to-yellow-500 focus:outline-none transition-all duration-200 font-bold text-lg flex items-center justify-center hover:scale-105"
            title={`Logged in as ${userEmail}`}
          >
            {getUserInitial()}
          </button>
        </div>
        
        <div className="relative flex justify-center mb-1">
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black p-1.5 rounded-full shadow-lg hover:from-yellow-400 hover:to-yellow-500 focus:outline-none transition-all duration-200 font-bold text-sm w-8 h-8 flex items-center justify-center"

          >
            {isSidebarOpen ? '←' : '→'}
          </button>
        </div>
        {isSidebarOpen ? (
          <div className='flex-1 overflow-y-auto p-1.5' >
            <h2 className="text-xs font-bold mb-2 text-center text-yellow-400 drop-shadow-lg tracking-wide">PICKSTONE</h2>
            <ul className="space-y-1">
              {slides.map((slide, index) => (
                <li
                key={index}
                className={`flex items-center p-1.5 cursor-pointer ${index === currentSlide ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-black' : 'bg-gray-700/80 hover:bg-gray-600/80'} transition-all rounded-md shadow-sm hover:shadow-md`}
                onClick={() => handleSlideClick(index)}
              >
                <div className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${index === currentSlide ? 'bg-yellow-300 text-black' : 'bg-gray-500 text-white'}`}>
                  {index + 1}
                </div>
                <span className="text-xs font-semibold ml-2 truncate">{slide.heading}</span>
              </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className="flex-1 overflow-y-auto">
            <ul className="flex flex-col items-center space-y-2 mt-8 px-1" >
              {slides.map((_, index) => (
                <li
                  key={index}
                  className={`w-6 h-6 flex items-center justify-center cursor-pointer rounded-full text-xs font-bold ${index === currentSlide ? 'bg-yellow-400 text-black shadow-lg' : 'bg-gray-500 text-white hover:bg-gray-400 shadow-sm'}`}
                  onClick={() => handleSlideClick(index)}
                >
                  {index + 1}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* Main Content */}
      <div className="flex-grow flex flex-col transition-all duration-300 relative overflow-auto">
      {(slides[currentSlide].type === 'scene' || slides[currentSlide].type === '360') && progress < 100 && (
          <div className="fixed inset-0 z-[1006] flex flex-col items-center justify-center bg-gray-900 bg-opacity-95 px-4 py-8">
            {/* Mining-themed loading animation */}
            <div className="relative w-full max-w-md flex flex-col items-center">
              {/* Rotating pickaxe */}
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center">
                <div className="text-4xl sm:text-6xl animate-spin" style={{ animationDuration: '2s' }}>
                  ⛏️
                </div>
              </div>
              
              {/* Gold nuggets falling */}
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2">
                <div className="text-lg sm:text-2xl animate-bounce" style={{ animationDelay: '0s', animationDuration: '1.5s' }}>
                  🪙
                </div>
              </div>
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2">
                <div className="text-lg sm:text-2xl animate-bounce" style={{ animationDelay: '0.5s', animationDuration: '1.5s' }}>
                  🪙
                </div>
              </div>
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2">
                <div className="text-lg sm:text-2xl animate-bounce" style={{ animationDelay: '1s', animationDuration: '1.5s' }}>
                  🪙
                </div>
              </div>
            </div>
            
            {/* Loading text with mining theme */}
            <div className="mt-6 sm:mt-8 text-center w-full max-w-lg">
              <h1 className="text-white text-xl sm:text-2xl font-bold mb-2">Mining Data...</h1>
              <p className="text-yellow-400 text-base sm:text-lg font-semibold">Extracting Gold Mining Information</p>
              
              {/* Bouncing loading bar */}
              <div className="mt-4 sm:mt-6 w-full max-w-xs sm:max-w-sm mx-auto bg-gray-700 rounded-full h-2 sm:h-3 overflow-hidden">
                <div className="h-full bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full animate-pulse"></div>
              </div>
              
              {/* Loading text */}
              <p className="text-yellow-300 text-base sm:text-lg font-bold mt-2">Loading...</p>
            </div>
          </div>
        )}
        <div className="flex-grow flex items-center justify-center bg-gray-400 overflow-hidden">
          {renderSlideContent()}
        </div>
        {/* Description Box */}
        {/* {showDescription && slides[currentSlide].content.description && (
          <div className="absolute bottom-14 left-0 w-full bg-gray-100 p-4 shadow-lg flex justify-between items-center text-gray-700 z-50">
            <p dangerouslySetInnerHTML={{ __html: slides[currentSlide].content.description }}></p>
            <button
              onClick={() => setShowDescription(false)}
              className="text-gray-500 hover:text-gray-700 font-bold text-sm w-fit"
            >
              &times;
            </button>
          </div>
        )} */}


        {slides[currentSlide].type === 'scene' && (
          <>

            {/* North Arrow */}
            <div className="absolute top-2 left-2 sm:top-4 sm:left-4 z-50">
              <div className="bg-white border-2 border-yellow-400 rounded-full p-2 shadow-lg">
                <div className="flex flex-col items-center justify-center">
                  <svg 
                    width="28" 
                    height="28" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    className="text-yellow-600"
                    style={{ 
                      transform: `rotate(${northArrowRotation}deg)`,
                      transition: 'transform 0.1s ease-out'
                    }}
                  >
                    {/* North arrow */}
                    <path 
                      d="M12 1L18 10L12 7L6 10L12 1Z" 
                      fill="currentColor"
                    />
                    {/* North arrow line */}
                    <line 
                      x1="12" 
                      y1="10" 
                      x2="12" 
                      y2="12" 
                      stroke="currentColor" 
                      strokeWidth="6" 
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Top Right Control Panel */}
            <div className="absolute top-1 right-1 sm:top-2 sm:right-2 bg-white border border-yellow-400 rounded shadow z-50 overflow-hidden">
              {/* Collapsible Header */}
              <div className="flex items-center justify-center p-1 border-b border-gray-200">
                <button
                  onClick={() => setIsControlPanelCollapsed(!isControlPanelCollapsed)}
                  className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center text-yellow-500 hover:text-yellow-600 transition-all duration-200"
                  title={isControlPanelCollapsed ? "Expand Controls" : "Collapse Controls"}
                >
                  <span className={`text-xs transition-transform duration-200 ${isControlPanelCollapsed ? '' : 'rotate-180'}`}>
                    ▼
                  </span>
                </button>
              </div>
              
              {/* Control Buttons Container */}
              <div className={`transition-all duration-300 ease-in-out ${isControlPanelCollapsed ? 'max-h-0 opacity-0' : 'max-h-96 opacity-100'}`}>
                <div className="p-0.5 flex flex-col gap-0.5">
                  {/* Scribble Toggle Button */}
                  <button
                    onClick={handleToggleScribbleMode}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      isScribbleMode ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Toggle Scribble Mode"
                  >
                    <span className="text-xs">✏️</span>
                  </button>

                  {/* Background Control Button */}
                  <button
                    onClick={() => setBackgroundMode((prev) => (prev + 1) % 3)}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      backgroundMode === 0 ? 'bg-gray-500 text-white' :
                      backgroundMode === 1 ? 'bg-white text-gray-800 border border-gray-300' :
                      'bg-black text-white'
                    }`}
                    title="Toggle Background"
                  >
                    <span className="text-xs">{backgroundMode === 0 ? '🌅' : backgroundMode === 1 ? '☀️' : '🌙'}</span>
                  </button>

                  {/* Unified Panel Button */}
                  <button
                    onClick={() => setShowUnifiedPanel(!showUnifiedPanel)}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      showUnifiedPanel ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Panel Controls"
                  >
                    <span className="text-xs">📋</span>
                  </button>

                  {/* Measurements Button */}
                  <button
                    onClick={() => setShowMeasurements(!showMeasurements)}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      showMeasurements ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Measurements Tools"
                  >
                    <span className="text-xs">🔧</span>
                  </button>

                  {/* Fly Around Button */}
                  <button
                    onClick={() => setFlyAround(!isFlyAroundActive)}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      isFlyAroundActive ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Camera Fly Around"
                  >
                    <span className="text-xs">🎥</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Unified Panel */}
            {showUnifiedPanel && (
              <UnifiedPanel
                modelList={ModelListPK}
                layerVisibility={layerVisibility}
                onToggleVisibility={handleToggleVisibility}
                activePanel={activePanel}
                onPanelChange={setActivePanel}
                onClose={() => setShowUnifiedPanel(false)}
                panelWidth={panelWidth}
                onWidthChange={setPanelWidth}
              />
            )}

       
            <Canvas className="absolute inset-0" flat shadows gl={{ antialias: true }} camera={{ position: [0, 7000, 0], near: 0.5, far: 10000, fov: 35 }}>
              <SceneComponent
                currentSlide = {currentSlide}
                layerVisibility={layerVisibility} 
                cameraPosition={slides[currentSlide].content.cameraPosition}
                lookAt={slides[currentSlide].content.lookAt}
                animateCamera={previousSlideWasScene}
                onThreeReady={setThree}
              />
            </Canvas>
            {/* Add the slicer component */}
            {three && <SceneSlicer three={three} />}

            <BottomBarContainer showUnifiedPanel={showUnifiedPanel} panelWidth={panelWidth}/>
            <Measurements showMeasurements={showMeasurements} />
            <ColorChange/>
            <ObjectDetails/>
            <Info/>
          </>



        )}


        {/* Scribble Component */}
        <Scribble
          isScribbleMode={isScribbleMode}
          selectedColor={selectedColor}
          onColorChange={setSelectedColor}
        />

        

        {/* Footer Navigation */}
        {/* <div className="py-1 bg-blue-200 text-blue-900 flex justify-between items-center px-4">
          <button
            onClick={() => handleSlideClick((currentSlide - 1 + slides.length) % slides.length)}
            className="bg-blue-600 text-white w-fit px-3 py-1 md:px-4 md:py-2 rounded shadow-md hover:bg-blue-700"
          >
            Previous
          </button>
          <span className="text-center text-sm md:text-lg w-fit">
            <div className="w-fit p-2 h-5  md:h-12 flex items-center justify-center rounded-full shadow bg-gray-100 font-bold">
              {currentSlide + 1} / {slides.length}
            </div>
          </span>
          <button
            onClick={() => handleSlideClick((currentSlide + 1) % slides.length)}
            className="bg-blue-600 text-white w-fit px-3 py-1 md:px-4 md:py-2 rounded shadow-md hover:bg-blue-700"
          >
            Next
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Presentation;
